//Must be first!
//import 'babel-polyfill';
import '@babel/polyfill';

import React from 'react';
import {render} from 'react-dom';

import {AuthFormComponent} from './separatecomponents/AuthFormComponent';
import {AuthFormComponent as AuthFormComponentNew, AUTH_MODE} from './separatecomponents/AuthFormComponentNew';
import {RecoverPasswordFormComponent} from './separatecomponents/RecoverPasswordFormComponent';
import {ResetPasswordFormComponent} from './separatecomponents/ResetPasswordFormComponent';
import {ContactUsFormComponent} from './shared/ContactUsFormComponent';
import {ContactUsFormComponent as ContactUsFormComponentNew} from './separatecomponents/ContactUsFormComponentNew';
import {AccountsListComponent} from './separatecomponents/AccountsListComponent';
import {InvoicesListComponent} from './separatecomponents/InvoicesListComponent';
import {PaymentsListComponent} from './separatecomponents/PaymentsListComponent';
import {AgentsListComponent} from './separatecomponents/AgentsListComponent';
import {NotificationSettingsComponent} from './separatecomponents/NotificationSettingsComponent';
import {AppErrorsComponent} from './separatecomponents/AppErrors';
import {AccountInfoComponent} from './separatecomponents/AccountInfo';
import {PaymentInfoComponent} from './separatecomponents/PaymentInfo';
import {InvoiceInfoComponent} from './separatecomponents/InvoiceInfo';
import {ServiceDashboardComponent} from './separatecomponents/ServiceDashboard';
import {AddAccountPaymentFormComponent} from './separatecomponents/AddAccountPaymentForm';
import {AddAccountAgentLimitFormComponent} from './separatecomponents/AddAccountAgentLimitForm';
import {KBArticleEditFormComponent} from './separatecomponents/KBArticleEditForm';
import {MailInfoComponent} from './separatecomponents/MailInfo';
import {AgentInfoComponent} from './separatecomponents/AgentInfo';
import {AdminDashboardComponent} from './separatecomponents/AdminDashboard';
import {AffiliatesListComponent} from './separatecomponents/AffiliatesListComponent';
import {AffiliateInfoComponent} from './separatecomponents/AffiliateInfo';
import {AffiliatePayoutInfoComponent} from './separatecomponents/AffiliatePayoutInfo';

import {setLocaleGlobal} from './shared/globalization';
setLocaleGlobal('en');

const defaultTimeZoneId = 'America/New_York';

window['AppComponents'] = {};

window['AppComponents'].RenderAuthFormComponent = function (nodeId, options) {

    const opt = {
        strings: null,
        timeZones: [], 
        countries: [],
        countryId: '',
        timeZoneId: '',
        verificationToken: '', 
        returnUrl: null, 
        recoverPasswordUrl: null,
        termsUrl: null,
        privacyUrl: null,
        loginApiUrl: null,
        socialAuthApiUrl: null,
        registerApiUrl: null,
        registerUrl: null,
        authMessage: '',
        socialErrors: null,
        loginButtonCaption: null,
        registerButtonCaption: null,
        isRegisterAuthAction: false,
        isCountryRequired: false,
        socialProviders: [],
        reCaptchaSiteKey: '',
        ...options
    };

    render(
        <AuthFormComponent 
            strings={opt.strings} 
            timeZones={opt.timeZones} 
            timeZoneId={opt.timeZoneId} 
            countries={opt.countries} 
            countryId={opt.countryId} 
            verificationToken={opt.verificationToken} 
            returnUrl={opt.returnUrl} 
            recoverPasswordUrl={opt.recoverPasswordUrl} 
            termsUrl={opt.termsUrl}
            privacyUrl={opt.privacyUrl}
            loginApiUrl={opt.loginApiUrl} 
            socialAuthApiUrl={opt.socialAuthApiUrl}
            registerApiUrl={opt.registerApiUrl} 
            registerUrl={opt.registerUrl}
            authMessage={opt.authMessage}
            socialErrors={opt.socialErrors}
            loginButtonCaption={opt.loginButtonCaption}
            registerButtonCaption={opt.registerButtonCaption}
            isRegisterAuthAction={opt.isRegisterAuthAction}
            isCountryRequired={opt.isCountryRequired}
            socialProviders={opt.socialProviders}
            reCaptchaSiteKey={opt.reCaptchaSiteKey}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAuthFormNewComponent = function (nodeId, options) {

    const opt = {
        strings: null,
        timeZones: [], 
        countryId: '',
        timeZoneId: '',
        verificationToken: '', 
        returnUrl: null, 
        loginApiUrl: null,
        registerApiUrl: null,
        registerUrl: null,
        socialAuthApiUrl: null,
        authMessage: '',
        socialErrors: null,
        loginButtonCaption: null,
        registerButtonCaption: null,
        isRegisterAuthAction: false,
        isCountryRequired: false,
        socialProviders: [],
        reCaptchaSiteKey: '',
        ...options
    };

    render(
        <AuthFormComponentNew 
            strings={opt.strings} 
            timeZones={opt.timeZones} 
            timeZoneId={opt.timeZoneId} 
            countryId={opt.countryId} 
            verificationToken={opt.verificationToken} 
            returnUrl={opt.returnUrl} 
            loginApiUrl={opt.loginApiUrl}
            registerApiUrl={opt.registerApiUrl}
            registerUrl={opt.registerUrl}
            socialAuthApiUrl={opt.socialAuthApiUrl}
            authMessage={opt.authMessage}
            socialErrors={opt.socialErrors}
            loginButtonCaption={opt.loginButtonCaption}
            registerButtonCaption={opt.registerButtonCaption}
            mode={opt.isRegisterAuthAction ? AUTH_MODE.REGISTER : AUTH_MODE.LOGIN}
            socialProviders={opt.socialProviders}
            reCaptchaSiteKey={opt.reCaptchaSiteKey}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderRecoverPasswordFormComponent = function (nodeId, options) {

    const opt = {
        strings: null,
        verificationToken: '', 
        recoverPasswordApiUrl: null,
        email: '',
        isSetFocus: true,
        reCaptchaSiteKey: '',
        ...options
    };

    render(
        <RecoverPasswordFormComponent 
            strings={opt.strings} 
            verificationToken={opt.verificationToken} 
            recoverPasswordApiUrl={opt.recoverPasswordApiUrl} 
            email={opt.email}
            isSetFocus={opt.isSetFocus}
            reCaptchaSiteKey={opt.reCaptchaSiteKey}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderResetPasswordFormComponent = function (nodeId, options) {

    const opt = {
        strings: null,
        verificationToken: '', 
        resetPasswordApiUrl: null,
        email: null,
        userName: '',
        resetKey: null,
        isSetFocus: true,
        ...options
    };

    render(
        <ResetPasswordFormComponent 
            strings={opt.strings} 
            verificationToken={opt.verificationToken} 
            resetPasswordApiUrl={opt.resetPasswordApiUrl} 
            email={opt.email}
            userName={opt.userName}
            resetKey={opt.resetKey}
            isSetFocus={opt.isSetFocus}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderContactUsFormComponent = function (nodeId, options) {

    const opt = {
        strings: null,
        verificationToken: '', 
        contactUsApiUrl: null,
        email: null,
        name: '',
        message: null,
        maxAttachedSize: -1,
        isSetFocus: true,
        reCaptchaSiteKey: '',
        ...options
    };

    render(
        <ContactUsFormComponent 
            strings={opt.strings} 
            verificationToken={opt.verificationToken} 
            contactUsApiUrl={opt.contactUsApiUrl} 
            email={opt.email}
            name={opt.name}
            message={opt.message}
            maxAttachedSize={opt.maxAttachedSize}
            isSetFocus={opt.isSetFocus}
            reCaptchaSiteKey={opt.reCaptchaSiteKey}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderContactUsFormNewComponent = function (nodeId, options) {

    const opt = {
        strings: null,
        verificationToken: '', 
        contactUsApiUrl: null,
        email: null,
        name: '',
        message: null,
        maxAttachedSize: -1,
        isSetFocus: true,
        reCaptchaSiteKey: '',
        ...options
    };

    render(
        <ContactUsFormComponentNew
            strings={opt.strings} 
            verificationToken={opt.verificationToken} 
            contactUsApiUrl={opt.contactUsApiUrl} 
            email={opt.email}
            name={opt.name}
            message={opt.message}
            maxAttachedSize={opt.maxAttachedSize}
            isSetFocus={opt.isSetFocus}
            reCaptchaSiteKey={opt.reCaptchaSiteKey}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderNotificationSettingsComponent = function (nodeId, options) {

    const opt = {
        verificationToken: '', 
        settingsToken: '',
        ...options
    };

    render (
        <NotificationSettingsComponent
            id="NotificationSettings"
            strings={opt.strings}
            verificationToken={opt.verificationToken}
            settingsToken={opt.settingsToken}
            loadSettingsUrl="/api/app/getNotificationSettings"
            saveSettingsUrl="/api/app/saveEmailMailSubscription"
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAccountsList = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        pageNum: 1,
        pageSize: 50,
        accountFilter: '',
        agentFilter: '',
        jobFilter: '',
        deletedStateId: null,
        deletedStates: [],
        accountRoleTypeId: null,
        accountRoleTypes: [],
        ...options
    };

    render (
        <AccountsListComponent
            timeZoneId={opt.timeZoneId}
            pageNum={opt.pageNum}
            pageSize={opt.pageSize}
            accountFilter={opt.accountFilter}
            agentFilter={opt.agentFilter}
            jobFilter={opt.jobFilter}
            deletedStateId={opt.deletedStateId}
            deletedStates={opt.deletedStates}
            accountRoleTypeId={opt.accountRoleTypeId}
            accountRoleTypes={opt.accountRoleTypes}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderInvoicesList = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        pageNum: 1,
        pageSize: 50,
        accountFilter: '',
        invoiceFilter: '',
        invoiceTypeId: '',
        invoiceTypes: [],
        ...options
    };

    render (
        <InvoicesListComponent
            timeZoneId={opt.timeZoneId}
            pageNum={opt.pageNum}
            pageSize={opt.pageSize}
            accountFilter={opt.accountFilter}
            invoiceFilter={opt.invoiceFilter}
            invoiceTypeId={opt.invoiceTypeId}
            invoiceTypes={opt.invoiceTypes}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderPaymentsList = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        pageNum: 1,
        pageSize: 50,
        accountFilter: '',
        paymentFilter: '',
        paymentTypeId: '',
        paymentStateId: '',
        paymentTypes: [],
        paymentStates: [],
        ...options
    };

    render (
        <PaymentsListComponent
            timeZoneId={opt.timeZoneId}
            pageNum={opt.pageNum}
            pageSize={opt.pageSize}
            accountFilter={opt.accountFilter}
            paymentFilter={opt.paymentFilter}
            paymentTypeId={opt.paymentTypeId}
            paymentStateId={opt.paymentStateId}
            paymentStates={opt.paymentStates}
            paymentTypes={opt.paymentTypes}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAgentsList = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        pageNum: 1,
        pageSize: 50,
        agentFilter: '',
        versionFilter: '',
        jobFilter: '',
        deletedStateId: '',
        applicationTypeId: '',
        deletedStates: [],
        applicationTypes: [],
        ...options
    };

    render (
        <AgentsListComponent
            timeZoneId={opt.timeZoneId}
            pageNum={opt.pageNum}
            pageSize={opt.pageSize}
            agentFilter={opt.agentFilter}
            versionFilter={opt.versionFilter}
            jobFilter={opt.jobFilter}
            deletedStateId={opt.deletedStateId}
            applicationTypeId={opt.applicationTypeId}
            deletedStates={opt.deletedStates}
            applicationTypes={opt.applicationTypes}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAppErrors = function (nodeId, options) {

    const opt = {
        daysDepth: 10,
        errorsCount: 10,
        applicationTypeId: '',
        applicationTypes: [],
        versionFilter: '',
        ...options
    };

    render (
        <AppErrorsComponent
            daysDepth={opt.daysDepth}
            errorsCount={opt.errorsCount}
            applicationTypeId={opt.applicationTypeId}
            versionFilter={opt.versionFilter}
            versionFilterAllowed
            applicationTypes={opt.applicationTypes}
            errorsName="Recent application errors ({0} days)"
            errorsSource="/api/admin/getAppErrors"
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderJobErrors = function (nodeId, options) {

    const opt = {
        daysDepth: 10,
        errorsCount: 10,
        applicationTypeId: '',
        applicationTypes: [],
        versionFilter: '',
        ...options
    };

    render (
        <AppErrorsComponent
            daysDepth={opt.daysDepth}
            errorsCount={opt.errorsCount}
            applicationTypeId={opt.applicationTypeId}
            versionFilter={opt.versionFilter}
            versionFilterAllowed
            applicationTypes={opt.applicationTypes}
            errorsName="Recent job errors ({0} days)"
            errorsSource="/api/admin/getJobErrors"
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAccountInfo = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        accountId: 0,
        listSource: '',
        ...options
    };

    render (
        <AccountInfoComponent
            accountId={opt.accountId}
            timeZoneId={opt.timeZoneId}
            listSource={opt.listSource}
            applicationTypes={opt.applicationTypes}
            mailTypes={opt.mailTypes}
            eventTypes={opt.eventTypes}
            popupMessageTypes={opt.popupMessageTypes}
            destinationTypes={opt.destinationTypes}
            deletedStates={opt.deletedStates}
            usageStates={opt.usageStates}
            servicePlanTypes={opt.servicePlanTypes}
            paymentTypes={opt.paymentTypes}
            paymentStates={opt.paymentStates}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderPaymentInfo = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        paymentId: 0,
        listSource: '',
        ...options
    };

    render (
        <PaymentInfoComponent
            paymentId={opt.paymentId}
            timeZoneId={opt.timeZoneId}
            listSource={opt.listSource}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderInvoiceInfo = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        invoiceId: 0,
        listSource: '',
        ...options
    };

    render (
        <InvoiceInfoComponent
            invoiceId={opt.invoiceId}
            timeZoneId={opt.timeZoneId}
            listSource={opt.listSource}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderServiceDashboard = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        requestTypes: [],
        requestTypeId: null,
        ...options
    };

    render (
        <ServiceDashboardComponent
            timeZoneId={opt.timeZoneId}
            requestTypes={opt.requestTypes}
            requestTypeId={opt.requestTypeId}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAddAccountPaymentForm = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        timeZoneName: '',
        ...options
    };

    render (
        <AddAccountPaymentFormComponent
            verificationToken={opt.verificationToken}
            accountId={opt.accountId}
            accountName={opt.accountName}
            timeZoneId={opt.timeZoneId}
            timeZoneName={opt.timeZoneName}
            paymentTypes={opt.paymentTypes}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAddAccountAgentLimitForm = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        timeZoneName: '',
        ...options
    };

    render (
        <AddAccountAgentLimitFormComponent
            verificationToken={opt.verificationToken}
            accountId={opt.accountId}
            accountName={opt.accountName}
            timeZoneId={opt.timeZoneId}
            timeZoneName={opt.timeZoneName}
            maxAgents={opt.maxAgents}
            basePrice={opt.basePrice}
            summaryDiscountPercent={opt.summaryDiscountPercent}
            monthSize={opt.monthSize}
            restDays={opt.restDays}
            estimatedPrice={opt.estimatedPrice}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderKBArticleEditForm = function (nodeId, options) {

    const opt = {
        ...options
    };

    render (
        <KBArticleEditFormComponent
            verificationToken={opt.verificationToken}
            articleData={opt.articleData}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderMailInfo = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        mailId: 0,
        listSource: '',
        ...options
    };

    render (
        <MailInfoComponent
            mailId={opt.mailId}
            timeZoneId={opt.timeZoneId}
            listSource={opt.listSource}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAgentInfo = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        agentId: 0,
        listSource: '',
        ...options
    };

    render (
        <AgentInfoComponent
            agentId={opt.agentId}
            timeZoneId={opt.timeZoneId}
            listSource={opt.listSource}
            serverTypes={opt.serverTypes}
            jobTypes={opt.jobTypes}
            deletedStates={opt.deletedStates}
            eventTypes={opt.eventTypes}
            messageTypes={opt.messageTypes}
            appEventTypes={opt.appEventTypes}
            usageStates={opt.usageStates}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAdminDashboard = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        jobTypes: [],
        applicationTypes: [],
        backupTypes: [],
        serverTypes: [],
        destinationTypes: [],
        mailTypes: [],
        presetData: {},
        displayOrders: [],
        ...options
    };

    render (
        <AdminDashboardComponent
            timeZoneId={opt.timeZoneId}
            jobTypes={opt.jobTypes}
            applicationTypes={opt.applicationTypes}
            backupTypes={opt.backupTypes}
            serverTypes={opt.serverTypes}
            destinationTypes={opt.destinationTypes}
            mailTypes={opt.mailTypes}
            presetData={opt.presetData}
            displayOrders={opt.displayOrders}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAffiliatesList = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        pageNum: 1,
        pageSize: 50,
        affiliateFilter: '',
        siteId: '',
        sites: [],
        ...options
    };

    render (
        <AffiliatesListComponent
            timeZoneId={opt.timeZoneId}
            pageNum={opt.pageNum}
            pageSize={opt.pageSize}
            affiliateFilter={opt.affiliateFilter}
            siteId={opt.siteId}
            sites={opt.sites}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAffiliateInfo = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        affiliateId: 0,
        listSource: '',
        ...options
    };

    render (
        <AffiliateInfoComponent
            affiliateId={opt.affiliateId}
            timeZoneId={opt.timeZoneId}
            listSource={opt.listSource}
        />,
        document.getElementById(nodeId)
    )
}

window['AppComponents'].RenderAffiliatePayoutInfo = function (nodeId, options) {

    const opt = {
        timeZoneId: defaultTimeZoneId,
        affiliateId: 0,
        payoutId: 0,
        ...options
    };

    render (
        <AffiliatePayoutInfoComponent
            payoutId={opt.payoutId}
            affiliateId={opt.affiliateId}
            timeZoneId={opt.timeZoneId}
        />,
        document.getElementById(nodeId)
    )
}
